/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useData1 } from "../data/useData1";
import { useData2 } from "../data/useData2";
import { useChart1 } from "../transformers/useChart1";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { dictionaryService } from "../../../dataFlow";
import { useExport, useSubscriptionProviderContext } from "../../../shared";

export const ComponentChart1: React.FC<{ context: ContextReport1 }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const payload = useHookSubscribe(null, context.payloadChart1);
  const payload2 = useHookSubscribe(null, context.payloadChart2);
  const data = useData1(payload);
  const data2 = useData2(payload2);
  const chartData = useChart1(data, data2);
  const source = useHookSubscribe(null, context.sources$);
  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);

  if (!window["exportMode"] && (!chartData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }

  if (window["exportMode"]) {
    window["exportReady"] = chartData && context.readyState !== ComponentContextReadyState.Loading;
  }

  return (
    <>
      <ComponentTitle>AP Agriculture Terminal</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} loader={<ComponentPreloader />} />
      <ComponentFootnote>*based on Soybean, Rice, Wheat, Corn Grain</ComponentFootnote>
    </>
  );
};
